import { render, staticRenderFns } from "./dialogCallsUser.vue?vue&type=template&id=2ca2a947&scoped=true&"
import script from "./dialogCallsUser.vue?vue&type=script&lang=js&"
export * from "./dialogCallsUser.vue?vue&type=script&lang=js&"
import style0 from "./dialogCallsUser.vue?vue&type=style&index=0&id=2ca2a947&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca2a947",
  null
  
)

export default component.exports